<template>
  <div class="bd_radius_large bg_white" :class="showHeader && showSearchBtn ? 'paddings_l' : ''">
    <el-form :inline="true" v-if="showHeader && showSearchBtn">
      <el-form-item :label="item.name" v-for="item in scInfo" :style="item.attrs" :key="item.prop" v-show="item.type != 'fix'">
        <div v-if="item.type == 'text'">
          <el-input
            v-if="item.oninput"
            class="miniInput"
            :placeholder="item.placeholder"
            v-model="searchForm[item.prop]"
            @keyup="searchForm[item.prop] = oninput(searchForm[item.prop], item.oninput)"
            @keyup.enter.stop="search(0)"
          >
          </el-input>
          <el-input v-else :placeholder="item.placeholder" v-model="searchForm[item.prop]" @keyup.enter.stop="search(0)"> </el-input>
        </div>
        <div v-if="item.type == 'hide'">
          <el-input :placeholder="item.placeholder" style="display: none" v-model="searchForm[item.prop]"> </el-input>
        </div>
        <div v-if="item.type == 'date'">
          <el-date-picker
            range-separator="至"
            type="daterange"
            v-model="searchForm[item.prop]"
            :default-time="[new Date(2000, 1, 1, 0, 0, 0), new Date(2000, 2, 1, 23, 59, 59)]"
            value-format="YYYY-MM-DD HH:mm:ss"
            format="YYYY-MM-DD HH:mm:ss"
            end-placeholder="结束日期"
            start-placeholder="开始日期"
            :clearable="item.clearable && item.clearable == 'close' ? false : true"
          ></el-date-picker>
        </div>
        <!-- timeDisabledDate 可设置可选时间范围 传入一个函数 -->
        <div v-if="item.type == 'dates' || item.type == 'multiDates'">
          <el-select v-model="searchForm[item.elProp]" value-key="id" class="padding_r_s" style="width: 120px; margin-right: 10px">
            <el-option v-for="opt in searchForm[item.elProp + 'List']" :key="opt.id" :label="opt.name" :value="opt.id"></el-option>
          </el-select>
          <el-date-picker
            range-separator="至"
            type="daterange"
            v-model="searchForm[item.prop]"
            :default-time="[new Date(2000, 1, 1, 0, 0, 0), new Date(2000, 2, 1, 23, 59, 59)]"
            value-format="YYYY-MM-DD HH:mm:ss"
            format="YYYY-MM-DD HH:mm:ss"
            end-placeholder="结束日期"
            start-placeholder="开始日期"
            :disabled-date="
              item.timeDisabledDate ||
              (() => {
                return false
              })
            "
          ></el-date-picker>
        </div>
        <div v-if="item.type == 'select'">
          <el-select v-model="searchForm[item.prop]" value-key="id" @change="selectChange($event, item)" clearable filterable placeholder="选择" :style="{ width: (item.width || 120) + 'px' }">
            <el-option v-for="opt in item.optionList" :key="opt.id" :label="opt.name" :value="item.prop == 'storeName' ? opt.name : opt.id"></el-option>
          </el-select>
        </div>
        <div v-if="item.type == 'multipleSelect'">
          <el-select style="width: 140px" clearable filterable placeholder="请选择" v-model="searchForm[item.optionList[0]]" @change="filterMult($event, item.dict2, item.optionList[1])">
            <el-option v-for="ch in channelsList" :key="ch.id" :label="ch.name" :value="ch.id"></el-option>
          </el-select>
          &nbsp;-&nbsp;
          <el-select style="width: 140px" clearable filterable placeholder="请选择" v-model="searchForm[item.optionList[1]]">
            <el-option v-for="tbitem in tabSelectData" :key="tbitem.id" :label="tbitem.name" :value="tbitem.id"></el-option>
          </el-select>
        </div>
        <div v-if="item.type == 'range'" class="flex_row flex_center">
          <div class="miniInput">
            <el-input maxlength="4" max="300" :placeholder="item.placeholder" v-model="searchForm[item.prop[0]]"></el-input>
          </div>
          <span class="gutters_l_r">至</span>
          <div class="miniInput">
            <el-input maxlength="4" max="300" :placeholder="item.placeholder" v-model="searchForm[item.prop[1]]"></el-input>
          </div>
        </div>
        <div v-if="item.type == 'coupon'" class="flex">
          <el-select clearable filterable style="width: 120px" placeholder="请选择" v-model="searchForm[item.optionList[0]]" @change="selectVersion">
            <el-option v-for="cp in couponList" :key="cp.id" :label="cp.name" :value="cp.id"></el-option>
          </el-select>
          &nbsp;-&nbsp;
          <el-select clearable filterable style="width: 120px" placeholder="版本号" v-model="searchForm[item.optionList[1]]">
            <el-option v-for="tbitem in tabSelectData" :key="tbitem.id" :label="tbitem.version" :value="tbitem.id"></el-option>
          </el-select>
        </div>
      </el-form-item>
      <el-form-item class="hx" v-if="showSearchBtn">
        <el-button type="primary" @click.stop="search(0)" @touchstart.stop="search(0)">查询</el-button>
        <div class="gutter_l" v-for="i in handleList" :key="i.path">
          <el-button type="primary" v-if="i.path" @click="$openRef(i.path)">{{ i.title }}</el-button>
          <el-button type="primary" v-if="!i.path && i.dialogName" @click="openDialog(i.dialogName)">{{ i.title }}</el-button>
        </div>
      </el-form-item>
    </el-form>
    <div class="userTable" :class="showHeader ? 'gutter_t_l0' : ''">
      <el-table :data="tableData" v-loading="tableLoading" style="width: 100%" :show-header="showHeader">
        <el-table-column v-for="tbItem in tableInfo.fieldInfos" :key="tbItem.prop" :label="tbItem.name" :min-width="tbItem.width">
          <template #default="scope">
            <div v-if="tbItem.type == 'text'">
              <div v-if="tbItem.dict">
                <sapn v-if="tbItem.dict == 'PAY_METHOD' && scope.row.payPlatform == 2">合利宝支付-</sapn>
                {{ getStatusName(tbItem.dict, scope.row[tbItem.prop], scope.row) }}
              </div>
              <div v-else>
                {{ scope.row[tbItem.prop] }}
              </div>
            </div>
            <div v-if="tbItem.type == 'link'">
              <el-button type="text" @click="$openRef(tbItem.path + scope.row[tbItem.id])">
                {{ scope.row[tbItem.prop] || scope.row[tbItem.prop2] }}
              </el-button>
            </div>
            <div v-if="tbItem.type == 'date'">
              <p>{{ getDate(scope.row[tbItem.prop]) }}</p>
              <p>{{ getTime(scope.row[tbItem.prop]) }}</p>
            </div>
            <div v-if="tbItem.type == 'store'">
              <p class="line" v-if="scope.row[tbItem.prop]">{{ scope.row[tbItem.storeAttrs[1]] ? scope.row[tbItem.storeAttrs[1]] : scope.row[tbItem.storeAttrs[0]] }}</p>
            </div>
            <div v-if="tbItem.type == 'money'">
              <!-- //isfull 代表金额不需要除以100 -->
              <p :style="tbItem.attrs ? tbItem.attrs : scope.row[tbItem.prop] >= 0 ? 'color:#000' : 'color:#ff4949'">￥{{ amtFormat(scope.row[tbItem.prop], tbItem.isfull || '') }}</p>
            </div>
            <div v-if="tbItem.type == 'number'">
              <p :style="tbItem.attrs ? tbItem.attrs : scope.row[tbItem.prop] >= 0 ? 'color:#666' : 'color:#ff4949'">{{ scope.row[tbItem.prop] || 0 }}</p>
            </div>
            <div v-if="tbItem.type == 'user'">
              <!-- 列表都不展示用户图片 -->
              <!-- :userImgPath="tbItem.userAttrs[3] != -1 ? scope.row[tbItem.userAttrs[3]] : '-1'" -->
              <UserInfo
                v-if="scope.row[tbItem.userAttrs[2]] || scope.row[tbItem.userAttrs[1]]"
                :userId="scope.row[tbItem.userAttrs[0]]"
                :userName="scope.row[tbItem.userAttrs[1]]"
                :userPhone="scope.row[tbItem.userAttrs[2]]"
                :userImgPath="-1"
              >
                <template v-slot:isnew v-if="scope.row[tbItem.userAttrs[4]]">
                  <span class="qy_tip">{{ '@' + scope.row[tbItem.userAttrs[4]] || '' }}</span>
                </template>
                <template v-slot:isnew v-if="tbItem.isNew && scope.row[tbItem.isNew] == 1">
                  <span class="newCust">新用户</span>
                </template>
              </UserInfo>
            </div>
            <div v-if="tbItem.type == 'slot'">
              <slot :name="tbItem.prop" :data="scope.row" :datetime="timestamp"></slot>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="flex_bet">
        <div class="flex gutter_t_l pull_left">
          <!-- 导出下载链接 -->
          <div class="bottom_btn text_center" v-if="downOutSingle" @click="downCode">导出</div>
          <div class="bottom_btn text_center gutter_l" v-if="downOutSingle" @click="check">查看报表</div>
          <!-- 导出资源 -->
          <div class="bottom_btn text_center" v-if="downOut" @click="downOrderList">导出</div>
        </div>
        <div class="gutter_b">
          <p class="gutter_t_l">
            <el-pagination
              class="pull_right"
              v-model:currentPage="searchForm.page"
              :page-size="searchForm.size"
              layout="total, prev, pager, next"
              :total="searchForm.total"
              @current-change="handleChange"
            >
            </el-pagination>
          </p>
        </div>
      </div>
    </div>
  </div>

  <!-- 下载报表 -->
  <el-dialog title="下载报表" v-model="downVisible">
    <div class="gutter_t_l">
      <el-table :data="downList">
        <el-table-column label="操作时间" width="105">
          <template #default="scope">
            <p>
              {{ getDate(scope.row.createTime) }}
            </p>
            <p>
              {{ getTime(scope.row.createTime) }}
            </p>
          </template>
        </el-table-column>
        <el-table-column label="操作人" width="80">
          <template #default="scope">
            <p>{{ scope.row.createMen }}</p>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="105">
          <template #default="scope">
            <p v-if="scope.row.downloadStatus == 1">处理中</p>
            <p v-if="scope.row.downloadStatus == 2">处理成功</p>
            <p v-if="scope.row.downloadStatus == 3">处理失败</p>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template #default="scope">
            <el-button type="primary" v-if="scope.row.downloadUrl" @click="down(scope.row)">下载报表</el-button>
            <el-button class="down_btn" :loading="scope.row.downloadStatus == 1" @click="handDownload(scope.row)">重新导出 </el-button>
          </template>
        </el-table-column>
      </el-table>
      <p class="gutter_t_l text_right">
        <el-pagination :page-size="downForm.size" v-model:currentPage="downForm.page" layout="total, prev, pager, next" :total="downForm.total" @current-change="downChange"> </el-pagination>
      </p>
    </div>
  </el-dialog>
</template>

<script>
import { getStorage, setStorage } from '@/utils/helpers/storage'
import dickeyval from '@/utils/dickeyval.js'
import { deepClone, debounce } from '@/utils/tool'
import timer from '@/utils/helpers/timer.js'
export default {
  name: 'table',
  props: {
    dataSize: {
      type: Number,
      default: 10
    },
    searchInfo: {
      type: Array,
      default: []
    },
    tableInfo: {
      type: Object,
      default: {}
    },
    handleList: {
      type: Array,
      default: () => {
        return []
      }
    },
    isMercId: Boolean,
    downOut: Boolean,
    downOutSingle: Boolean,
    showHeader: {
      type: Boolean,
      default: true
    },
    showSearchBtn: {
      type: Boolean,
      default: true
    },
    downloadType: String,
    downOutTitle: {
      type: String,
      default: '表格导出数据'
    }
  },
  computed: {
    mercId() {
      return getStorage('userInfo').mercId
    }
  },
  data() {
    return {
      tableData: [],
      tableLoading: false,
      refresh: false,
      searchForm: {
        page: 1,
        size: 10,
        total: ''
      },
      oldSearchForm: {},
      timestamp: '',
      downVisible: false,
      downList: [],
      downForm: {
        page: 1,
        size: 10,
        total: 0
      },
      searchDownForm: {},
      payTypeList: getStorage('payTypeList') || [],
      storeList: getStorage('storeList') || [],
      teamUnitList: getStorage('teamUnitList') || [],
      // orderTypeList: [],
      scInfo: [],
      couponList: null,
      tabSelectData: [],
      searchData: {},
      channelsList: []
    }
  },
  watch: {
    searchInfo: {
      handler(newVal, oldVal) {
        // JSON.parse(JSON.stringify(newVal)) 无法克隆函数
        if (newVal && JSON.stringify(newVal) !== '{}') {
          // this.scInfo = JSON.parse(JSON.stringify(newVal))
          this.scInfo = this.cloneWithFunction(newVal)
        } else if (oldVal && JSON.stringify(oldVal) !== '{}') {
          // this.scInfo = JSON.parse(JSON.stringify(oldVal))
          this.scInfo = this.cloneWithFunction(oldVal)
        }
        if (this.scInfo.length > 0) {
          this.searchForm.size = this.dataSize || 10
          this.scInfo.forEach(item => {
            if (item.elProp) {
              this.searchForm[item.elProp] = this.searchForm[item.elProp] || '1'
              this.searchForm[item.elProp + 'List'] = dickeyval.getValList(item.dict)
            }
            if (item.type == 'select' && item.dict) {
              if (item.dict == 'payType') {
                if (this.payTypeList && this.payTypeList.length == 0) {
                  this.$common.queryAllPayTypeList().then(data => {
                    item.optionList = data || []
                    setStorage('payTypeList', data || [])
                    this.payTypeList = data || []
                  })
                } else {
                  item.optionList = this.payTypeList
                }
              } else if (item.dict == 'allStore') {
                if (this.storeList.length == 0) {
                  this.$common.getStoreList().then(data => {
                    item.optionList = data || []
                    this.storeList = data || []
                  })
                } else {
                  item.optionList = this.storeList
                }
              } else if (item.dict == 'teamUnitList') {
                if (this.teamUnitList.length) {
                  item.optionList = this.teamUnitList
                } else {
                  this.$common.getTeamUnitList().then(data => {
                    item.optionList = data || []
                  })
                }
              } else if (item.dict == 'allOrderType') {
                // this.$common.getOrderTypeList()
                let list = [
                  { id: 6, name: '礼券售卖' },
                  { id: 1, name: '积分折扣' },
                  { id: 2, name: '团购订单' },
                  { id: 3, name: '付款订单' },
                  { id: 4, name: '拼团订单' },
                  { id: 7, name: '积分兑换订单' },
                  { id: 9, name: '优卡订单' }
                ]
                let orderTypeList = getStorage('otList') || []
                orderTypeList.forEach(item => {
                  if (item == 1) {
                    list.unshift({
                      name: '商品订单',
                      id: 5
                    })
                  } else if (item == 3) {
                    list.unshift({
                      name: '家政订单',
                      id: 12
                    })
                  } else if (item == 2) {
                    list.unshift({
                      name: '洗护订单',
                      id: 8
                    })
                  }
                })
                item.optionList = list
                // this.orderTypeList = data || []
              } else {
                let optionList = dickeyval.getValList(item.dict) // 本地字典
                if (!optionList) {
                  let arr = this.getDictList(item.dict) || [] // 数据库字典-需要改造一下数据
                  optionList = arr.map(item => {
                    return {
                      id: item.val,
                      name: item.text
                    }
                  })
                }
                item.optionList = optionList
              }
            }
            if (item.type == 'fix' || item.val) {
              this.searchForm[item.prop] = item.val || ''
            } else {
              this.searchForm[item.prop] = this.searchForm[item.prop] || ''
            }
            if (item.type == 'coupon') {
              if (!this.couponList) {
                this.queryCouponList()
              }
              this.searchForm[item.optionList[0]] = this.searchForm[item.optionList[0]] || ''
              this.searchForm[item.optionList[1]] = this.searchForm[item.optionList[1]] || ''
            }
            if (item.type == 'multipleSelect') {
              let dictlist = dickeyval.getValList(item.dict) // 本地字典
              if (!dictlist) {
                dictlist = this.getDictList(item.dict) // 数据库字典
              }
              this.channelsList = dictlist || [] //字典
              this.searchForm[item.optionList[0]] = this.searchForm[item.optionList[0]] || ''
              this.searchForm[item.optionList[1]] = this.searchForm[item.optionList[1]] || ''
            }
          })
        }
        this.initSearch()
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    cloneWithFunction(obj) {
      if (obj === null || typeof obj !== 'object') {
        return obj
      }

      if (obj instanceof Date) {
        return new Date(obj.getTime())
      }

      if (obj instanceof Array) {
        return obj.reduce((arr, item, i) => {
          arr[i] = this.cloneWithFunction(item)
          return arr
        }, [])
      }

      if (obj instanceof Object) {
        return Object.keys(obj).reduce((newObj, key) => {
          const value = obj[key]
          if (typeof value === 'function') {
            newObj[key] = value.bind(obj) // 如果需要绑定函数的原作用域，可以使用 .bind(obj)
          } else {
            newObj[key] = this.cloneWithFunction(value)
          }
          return newObj
        }, {})
      }
    },
    initSearch() {
      let oldSearchForm = getStorage('oldTableSearchForm') || {}
      this.searchForm.size = this.dataSize || 10
      let query = this.$route.query
      if (this.searchInfo && this.searchInfo.length > 0) {
        let searchInfo = JSON.parse(JSON.stringify(this.searchInfo))
        searchInfo.forEach(item => {
          if (item.type == 'select') {
            // if (query[item.prop] === '0') {
            //   this.searchForm[item.prop] = '0'
            // } else if (query[item.prop] && query[item.prop] > 0) {
            //   this.searchForm[item.prop] = Number(query[item.prop])
            // } else {
            //   this.searchForm[item.prop] = ''
            // }
            this.searchForm[item.prop] = query[item.prop] === '0' ? '0' : Number(query[item.prop]) || ''
            if (item.dict) {
              let optionList = dickeyval.getValList(item.dict) // 本地字典
              if (!optionList) {
                let arr = this.getDictList(item.dict) || [] // 数据库字典-需要改造一下数据
                optionList = arr.map(item => {
                  return {
                    id: item.val,
                    name: item.text
                  }
                })
              }
              item.optionList = optionList
            }
            if (item.optionList) {
              let obj = item.optionList.find(itm => {
                let val = ''
                if (query[item.prop] === '0' && typeof itm.id === 'number') {
                  val = Number(query[item.prop])
                } else if (query[item.prop] && typeof itm.id === 'number') {
                  val = Number(query[item.prop])
                } else {
                  val = query[item.prop]
                }
                return itm.id === val
              })
              if (obj) {
                this.searchForm[item.prop] = obj.id
                if (item.prop == 'initPayChannel' || item.prop == 'initPayMethod') {
                  this.searchForm.payChannel = obj.value == 3 ? 3 : obj.value
                  this.searchForm.otherPayId = obj.value == 3 ? obj.id : ''
                }
              }
            }
          } else {
            this.searchForm[item.prop] = query[item.prop] || ''
          }
          if (item.elProp) {
            //组合
            this.searchForm[item.elProp] = query[item.elProp] || item.defaultVal || '1'
          }
          if (item.type == 'date' || item.type == 'dates' || item.type == 'multiDates') {
            let time = this.searchForm[item.prop]
            // 页面刷新query.time=null 进入页面query.time=undefined 由此来判断是否需要设置默认的查询天数
            if (!time && item.limitNum && query[item.prop] === undefined) {
              let limitTime = this.$common.InitialDays(item.limitNum)
              if (item.type == 'multiDates') {
                if (this.searchForm[item.elProp] == 2) {
                  this.searchForm[item.optionList[1][0]] = limitTime[0] || ''
                  this.searchForm[item.optionList[1][1]] = limitTime[1] || ''
                } else {
                  this.searchForm[item.optionList[0][0]] = limitTime[0] || ''
                  this.searchForm[item.optionList[0][1]] = limitTime[1] || ''
                }
              } else {
                this.searchForm[item.optionList[0]] = limitTime[0] || ''
                this.searchForm[item.optionList[1]] = limitTime[1] || ''
              }
              this.searchForm[item.prop] = limitTime
            } else {
              this.searchForm[item.prop] = query[item.prop] || ''
            }
          }
          if (item.type == 'fix' || item.val) {
            this.searchForm[item.prop] = item.val
          }
          if (item.type == 'fix' && oldSearchForm[item.prop] != this.searchForm[item.prop]) {
            this.refresh = true
          }
          if (item.type == 'coupon') {
            if (!this.couponList) {
              this.queryCouponList()
            }
            if (query[item.optionList[0]]) {
              this.searchForm[item.optionList[0]] = Number(query[item.optionList[0]]) || ''
              this.selectVersion()
              this.searchForm[item.optionList[1]] = Number(query[item.optionList[1]]) || ''
            }
          }
          if (item.type == 'multipleSelect') {
            let dictlist = dickeyval.getValList(item.dict) // 本地字典
            if (!dictlist) {
              dictlist = this.getDictList(item.dict) // 数据库字典
            }
            this.channelsList = dictlist || [] //字典

            if (query[item.optionList[0]]) {
              let num1 = query[item.optionList[0]] || ''
              let num2 = query[item.optionList[1]] || ''

              this.searchForm[item.optionList[0]] = num1
              this.filterMult(1, item.dict2, item.optionList[1])
              this.searchForm[item.optionList[1]] = num2
            }
          }
        })
      }
      this.searchForm.page = Number(query.page || 1)
      let row = this.searchForm.page - 1 <= 0 ? 0 : query.page - 1
      let startRow = this.refresh ? '0' : row * this.searchForm.size
      this.search(startRow)
    },
    search: debounce(function (startRow = 0) {
      let queryDisable = false // 是否禁止请求
      let messageError = '' // 提示错误内容
      let searchInfo = JSON.parse(JSON.stringify(this.scInfo))
      let singleNeedList = []
      searchInfo.forEach(item => {
        let value = this.searchForm[item.prop]
        if (item.type == 'date' || item.type == 'dates' || item.type == 'multiDates') {
          if (item.type == 'dates' || item.type == 'multiDates') {
            this.searchForm[item.elProp] = this.searchForm[item.elProp] || '1'
          }
          if (item.type == 'multiDates') {
            if (this.searchForm[item.elProp] == '2') {
              this.searchForm[item.optionList[1][0]] = value && value.length ? value[0] : ''
              this.searchForm[item.optionList[1][1]] = value && value.length ? value[1] : ''
            } else {
              this.searchForm[item.optionList[0][0]] = value && value.length ? value[0] : ''
              this.searchForm[item.optionList[0][1]] = value && value.length ? value[1] : ''
            }
          } else {
            this.searchForm[item.optionList[0]] = value && value.length ? value[0] : ''
            this.searchForm[item.optionList[1]] = value && value.length ? value[1] : ''
          }

          let dateRangeMonth = item.dateRangeMonth || '' // 日期查询范围月数限制
          if (dateRangeMonth && value && value[0] && value[1] && timer.monthDifference(value[0], value[1]) >= dateRangeMonth) {
            queryDisable = true
            messageError = `时间范围查询请限制在${dateRangeMonth}个月之内`
          }

          let dateRangeDay = item.dateRangeDay || '' // 日期查询范围月数限制
          if (dateRangeDay && value && value[0] && value[1] && timer.difference(value[0], value[1]) >= dateRangeDay) {
            queryDisable = true
            messageError = `时间范围查询请限制在${dateRangeDay}天之内`
          }
        }

        if (item.singleNeed) {
          if (item.type == 'date' || item.type == 'dates' || item.type == 'multiDates') {
            singleNeedList.push({
              name: item.name || '时间范围',
              prop: item.prop,
              value: value && value.length ? true : false // 是否有值
            })
          } else {
            singleNeedList.push({
              name: item.name,
              prop: item.prop,
              value: value ? true : false // 是否有值
            })
          }
        }
      })

      // 限制列表查询 最少有一项查询条件
      let singleNeedText = []
      let singleNeedBool = singleNeedList.every(item => {
        if (!item.value) {
          singleNeedText.push(item.name)
          return true
        }
      })
      if (singleNeedBool && singleNeedText.length) {
        queryDisable = true
        messageError = `缺少必要的查询条件（${singleNeedText.join('、')}）其中一项必选/填`
      }

      // 查询拦截
      if (queryDisable && messageError) {
        this.$message.error(messageError)
        return
      }
      this.tableLoading = true
      let data = {
        startRow: startRow[0] || 0 + '',
        pageSize: this.searchForm.size,
        page: this.searchForm.page || 1
      }
      let scForm = JSON.parse(JSON.stringify(this.searchForm))
      let scForm2 = JSON.parse(JSON.stringify(this.searchForm))
      searchInfo.forEach(item => {
        if (item.type == 'date' || item.type == 'dates' || item.type == 'multiDates') {
          if (item.type == 'multiDates') {
            data[item.elProp] = scForm[item.elProp] || '1'
            let oplist = data[item.elProp] == '2' ? item.optionList[1] : item.optionList[0]
            oplist.forEach(el => {
              data[el] = scForm[el]
            })
          } else {
            item.optionList.forEach(el => {
              data[el] = scForm[el]
            })
            if (item.type == 'dates') {
              data[item.elProp] = scForm[item.elProp] || '1'
            }
          }
        } else {
          if (item.prop == 'initPayChannel') {
            data.otherPayId = scForm2.otherPayId || ''
            data.payChannel = scForm2.payChannel || ''
          }
          if (item.prop == 'initPayMethod') {
            data.otherPayId = scForm2.otherPayId || ''
            data.payMethod = scForm2.payChannel || ''
          }
          if (item.type == 'coupon') {
            data[item.optionList[0]] = scForm[item.optionList[0]] || ''
            data[item.optionList[1]] = scForm[item.optionList[1]] || ''
          }
          if (item.type == 'multipleSelect') {
            data[item.optionList[0]] = scForm[item.optionList[0]] || ''
            data[item.optionList[1]] = scForm[item.optionList[1]] || ''
          }
        }
        data[item.prop] = data[item.prop] ? data[item.prop] : scForm[item.prop]
      })
      // data = {...data,...this.searchForm}  // 合并两个对象   //a.concat(b)  合并两个数组
      if (this.isMercId) {
        data.mercId = this.mercId
      }
      if (this.downOut || this.downOutSingle) {
        this.searchDownForm = JSON.parse(JSON.stringify(data))
      }
      setStorage('oldTableSearchForm', data)
      this.searchData = data
      this.$apis[this.tableInfo.apiUrl[0]][this.tableInfo.apiUrl[1]](data).then(res => {
        this.tableLoading = false
        if (res && res.httpCode == 200 && res.data) {
          this.tableData = res.data.list
          this.timestamp = res.timestamp
          this.searchForm.total = res.data.total
          this.searchForm.page = res.data.pageNum
          data.page = res.data.pageNum
          this.$router.replace({
            path: '',
            query: data
          })
        }
      })
    }, 200),
    //单独调用查询方法
    singleSearch(itmlist) {
      itmlist.forEach(itm => {
        this.searchForm[itm.name] = ''
        this.searchForm[itm.name] = itm.val
      })
      this.search(0)
    },
    selectChange(e, item) {
      //付款方式
      if (item && (item.prop == 'initPayChannel' || item.prop == 'initPayMethod')) {
        if (!e) {
          this.searchForm.payChannel = ''
          this.searchForm.otherPayId = ''
          this.searchForm.payMethod = ''
        } else {
          let optionList = item.optionList || []
          let obj = optionList.find(itm => {
            return itm.id == e
          })
          if (obj) {
            this.searchForm.payChannel = obj.value == 3 ? 3 : obj.value
            this.searchForm.otherPayId = obj.value == 3 ? obj.id : ''
          }
        }
      }
    },
    // 多种选择框
    filterMult(e, dict, val) {
      let indedx = Number(e) - 1
      this.searchForm[val] = ''
      let dictlist = dickeyval.getValList(dict[indedx]) // 本地字典
      if (!dictlist) {
        dictlist = this.getDictList(dict[indedx]) // 数据库字典
      }
      this.tabSelectData = dictlist
    },
    handleChange(e) {
      let oldSearchForm = getStorage('oldTableSearchForm')
      let flag = false
      this.scInfo.forEach(item => {
        //校验类型为 fix  的属性值是否相同，不同则不调用页面change方法
        if (item.type == 'fix' && oldSearchForm[item.prop] != this.searchForm[item.prop]) {
          flag = true
        }
      })
      if (flag) return
      let searchForm = this.searchForm
      let startRow = (e - 1) * searchForm.size
      this.search(startRow)
    },
    //导出
    downOrderList() {
      let url = ''
      if (this.downloadType == 6) {
        url = 'downOrderDealList'
      } else if (this.downloadType == 5) {
        url = 'downloadBillList'
      } else if (this.downloadType == 7) {
        url = 'downloadCardList'
      } else if (this.downloadType == 8) {
        url = 'downloadBillList'
      } else if (this.downloadType == 9) {
        url = 'exportWashList'
      } else if (this.downloadType == 10) {
        url = 'exportRefundList'
      } else if (this.downloadType == 11) {
        url = 'downloadUserCardBill'
      } else if (this.downloadType == 12) {
        url = 'downloadUserList'
      } else if (this.downloadType == 13) {
        url = 'downIntegralList'
      } else if (this.downloadType == 14) {
        url = 'partnerCommissionExport'
      } else if (this.downloadType == 15) {
        url = 'orderCommissionExport'
      } else if (this.downloadType == 16) {
        url = 'accountAssetExport'
      } else if (this.downloadType == 17) {
        url = 'couponIssueExport'
      } else if (this.downloadType == 18) {
        url = 'couponBatchUserExport'
      } else if (this.downloadType == 19) {
        url = 'exportOEMClothingList'
      }
      if (!url) return
      let num = 5000
      if (this.downloadType == 9 || this.downloadType == 19) {
        num = 50000
      }
      if (this.downloadType == 5 || this.downloadType == 7 || this.downloadType == 8) {
        num = 12000
      }
      if (this.searchForm.total <= num) {
        this.tableLoading = true
        this.$apis.finance[url](this.searchData).then(res => {
          if (res) {
            const blob = new Blob([res], { type: 'application/vnd.ms-excel' })
            const a = document.createElement('a')
            a.download = this.downOutTitle + '.xlsx'
            a.href = window.URL.createObjectURL(blob)
            a.click()
            a.remove()
            this.tableLoading = false
          } else {
            this.$message.error(res?.msg ?? '导出失败')
            this.tableLoading = false
          }
        })
      } else {
        this.$message.error(`导出的数据总数不能超过${num}条，请更改查询条件。`)
      }
    },

    check() {
      this.downVisible = true
      let row = this.downForm.page - 1
      let startRow = row * this.downForm.size
      this.listDownload(startRow)
    },
    queryCouponList() {
      this.$apis.application.queryCouponList({ status: 1, pageSize: 300 }).then(res => {
        if (res.httpCode == 200 && res.data) {
          this.couponList = res.data.list
        } else {
          this.$msg.error(res.msg)
        }
      })
    },
    selectVersion() {
      this.searchForm.couponRuleId = ''
      if (this.searchForm.couponId) {
        this.$apis.application
          .VersionList({
            couponId: this.searchForm.couponId
          })
          .then(res => {
            this.tabSelectData = res.data.list
          })
      }
    },
    listDownload(startRow = 0) {
      let toCheck = false
      if (this.downloadType) {
        this.$apis.order
          .listDownloadManager({
            startRow,
            downloadType: this.downloadType,
            pageSize: this.downForm.size
          })
          .then(res => {
            if (res.httpCode == 200 && res.data) {
              this.downList = res.data.list
              this.downForm.total = res.data.total
              res.data.list.forEach(function (item) {
                if (!item.downloadUrl) {
                  toCheck = true
                }
              })
              if (toCheck) {
                let _this = this
                setTimeout(function () {
                  _this.listDownload(0)
                }, 3000)
              }
            }
          })
      } else {
        console.log('下载类型（downloadType）值未设置')
      }
    },
    down(item) {
      window.open(item.downloadUrl)
    },
    handDownload(item) {
      this.$apis.order
        .handDownload({
          downloadId: item.id
        })
        .then(res => {
          if (res.httpCode == 200) {
            this.downOrderList()
          }
        })
    },
    downChange(e) {
      let downForm = this.downForm
      let startRow = (e - 1) * downForm.size
      this.listDownload(startRow)
    },
    getStatusName(dict, e, row) {
      if (dict == 'PAY_METHOD' && row.otherPayName) return row.otherPayName // 优先展示接口返回的支付名称
      let dictlist = []
      if (dict == 'PAY_METHOD') {
        if (this.payTypeList && this.payTypeList.length == 0) {
          this.$common.queryAllPayTypeList().then(data => {
            dictlist = data || []
            setStorage('payTypeList', data || [])
            this.payTypeList = data || []
          })
        } else {
          dictlist = this.payTypeList
        }
      } else {
        dictlist = dickeyval.getValList(dict)
        // 本地字典
        if (!dictlist) {
          dictlist = this.getDictList(dict) // 数据库字典
        }
      }
      if (e) {
        let obj = {}
        if (dict == 'PAY_METHOD') {
          let id = e == 3 ? row.otherPayId : e //支付方式是其它3的情况，就取值otherPayId来显示支付方式名称
          obj = dictlist.find(item => {
            return item.id == id
          })
        } else {
          obj = dictlist.find(item => {
            return item.id == e || item.val == e
          })
        }
        return obj ? obj.name || obj.text : '其它'
      } else {
        return ''
      }
    },
    downCode() {
      this.$apis[this.tableInfo.apiUrl[0]].downCodeList(this.searchDownForm).then(res => {
        if (res.httpCode == 200 && res.data) {
          window.open(res.data)
        } else {
          this.$msg.error(res?.msg ?? '导出失败')
        }
      })
    },
    openDialog(name) {
      if (name) {
        this.$emit(name)
      }
    }
    // calculateDaysDifference(date_1, date_2) {
    //   // 将日期转换为毫秒并计算它们之间的差值
    //   let startDate = new Date(date_1)
    //   let endDate = new Date(date_2)
    //   let difference = Math.abs(startDate - endDate)
    //   // 将毫秒转换为天数，并保留一位小数
    //   let daysDifference = parseFloat((difference / (1000 * 60 * 60 * 24)).toFixed(1))
    //   return daysDifference
    // }
  }
}
</script>

<style lang="less" scoped>
.miniInput {
  width: 100px;
  height: 32px;
}

.down_btn {
  cursor: pointer;
  font-weight: bold;
  border-radius: 4px;
  color: #00000080;
  background: #ffffff1a;
  box-sizing: border-box;
  border: 1px solid #00000033;
}
</style>
